<template>
	<div class="h-panel-body padding font-bold">
		<Row :space="9">
			<Cell width="6" v-for="(type,i) in typeList" :key="i">
				<div>
					<p>{{type.name}}</p>
					<p class="pnumber" v-if="money[type.code] && (money[type.code].debitAmount||money[type.code].creditAmount)">{{money[type.code].debitAmount||money[type.code].creditAmount|numFormat}}</p>
					<p class="pnumber" v-else>0.00</p>
					<router-link v-if="money[type.code] && money[type.code].voucherId" tag="button" :to="{name:'VoucherForm', params: { voucherId: money[type.code].voucherId}}" class="h-btn h-btn-green">查看凭证</router-link>
					<router-link v-else-if="type.type === 'jzsy' || (money[type.code] && (money[type.code].debitAmount || money[type.code].creditAmount))" tag="button" :to="{name:'VoucherForm', params: { checkData,type }}" class="h-btn h-btn-primary">生成凭证</router-link>
					<button v-else type="button" class="h-btn" disabled>无需结转</button>
				</div>
			</Cell>
		</Row>
		<div align="center" style="margin-top: 20px;">
			<button class="h-btn h-btn-text-primary h-btn-transparent" @click="back">上一步</button>
			<button class="h-btn h-btn-primary" @click="check">下一步</button>
			<button class="h-btn h-btn-green" @click="depreciatePreview" v-if="currentAccountSets.fixedAssetModule == 1">折旧计提</button>
			<button class="h-btn h-btn-green" @click="salaryAccruePreview" v-if="currentAccountSets.salaryModule == 1">工资计提</button>
		</div>

		<Modal v-model="showSalaryModal" :hasCloseIcon="false" :closeOnMask="false" :middle="true">
			<div slot="header">工资计提预览（{{checkYear}}年{{checkMonth}}期）</div>
			<div style="max-height: 400px; overflow: auto;">
				<table class="dep-table" v-if="salaryLines.length">
					<thead>
					<tr>
						<th>摘要</th>
						<th>科目</th>
						<th>借方</th>
						<th>贷方</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(line, index) in salaryLines" :key="index">
						<td>{{ line.summary }}</td>
						<td>{{ line.subjectName }}</td>
						<td align="right">{{ line.jie | numFormat }}</td>
						<td align="right">{{ line.dai | numFormat }}</td>
					</tr>
					</tbody>
				</table>
				<div class="text-center margin" v-else>当前期间没有需要计提的工资！</div>
			</div>
			<div class="text-center">
				<Button color="green" @click="doSalaryAccrue" :loading="salaryLoading" v-if="salaryLines.length">确认计提</Button>
				<Button @click="showSalaryModal=false">取消</Button>
			</div>
		</Modal>

		<Modal v-model="showDepModal" :hasCloseIcon="false" :closeOnMask="false" :middle="true">
			<div slot="header">折旧计提预览（{{checkYear}}年{{checkMonth}}期）</div>
			<div style="max-height: 400px; overflow: auto;">
				<table class="dep-table" v-if="depLines.length">
					<thead>
					<tr>
						<th>摘要</th>
						<th>科目</th>
						<th>借方</th>
						<th>贷方</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(line, index) in depLines" :key="index">
						<td>{{ line.summary }}</td>
						<td>{{ line.subjectName }}</td>
						<td align="right">{{ line.jie | numFormat }}</td>
						<td align="right">{{ line.dai | numFormat }}</td>
					</tr>
					</tbody>
				</table>
				<div class="text-center margin" v-else>当前期间没有需要计提折旧的资产！</div>
			</div>
			<div class="text-center">
				<Button color="green" @click="doDepreciate" :loading="depLoading" v-if="depLines.length">确认计提</Button>
				<Button @click="showDepModal=false">取消</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import StringUtils from 'string-utilz';

	export default {
		name: "checkout",
		props: {
			checkYear: [Number, String],
			checkMonth: [Number, String],
		},
		computed: {
			...mapState(['currentAccountSets']),
			typeList() {
				let isQy = this.currentAccountSets.accountingStandards === 0;
				return [
					{
						code: isQy ? '5401' : '6401',
						type: 'jzxscb',
						name: '结转销售成本',
						subject: isQy ? [5401, 1405] : [6401, 1405]
					},
					{
						code: '2211',
						type: 'jtzgxc',
						name: '计提职工薪酬',
						subject: isQy ? [this.codeConversion(560201), this.codeConversion(560101), 2211] : [this.codeConversion(660201), this.codeConversion(660101), 2211]
					},
					{
						code: '1602',
						type: 'jtzj',
						name: '计提折旧',
						subject: isQy ? [this.codeConversion(560207), 1602] : [this.codeConversion(660207), this.codeConversion(660107), 1602]
					},
					{
						code: '1801',
						type: 'txdtfy',
						name: '摊销待摊费用',
						subject: isQy ? [this.codeConversion(560212), 1801] : [this.codeConversion(660212), 1801]
					},
					{
						code: isQy ? '5401' : '6403',
						type: 'jtsj',
						name: '计提税金',
						subject: isQy ? [5403, this.codeConversion(222108), this.codeConversion(222113), this.codeConversion(222114)] : [6403, this.codeConversion(222108), this.codeConversion(222113), this.codeConversion(222114)]
					},
					{
						code: this.codeConversion('222102'),
						type: 'jzwjzzs',
						name: '结转未交增值税',
						subject: [this.codeConversion(22210103), this.codeConversion(222102)]
					},
					{
						code: isQy ? '5401' : '6801',
						type: 'jtsds',
						name: '计提所得税',
						subject: isQy ? [5801, this.codeConversion(222106)] : [6801, this.codeConversion(222106)]
					},
					{
						code: isQy ? '3103' : '4103',
						type: 'jzsy',
						name: '结转损益',
						subject: isQy ? [3103] : [4103]
					}
				]
			}
		},
		data() {
			return {
				selected: 'carry-forward',
				checkData: {},
				money: {},
				showDepModal: false,
				depLines: [],
				depLoading: false,
				showSalaryModal: false,
				salaryLines: [],
				salaryLoading: false
			}
		},
		methods: {
			check() {
				this.$router.push({name: 'Check', params: this.checkData})
			},
			back() {
				this.$router.back()
			},
			depreciatePreview() {
				this.depLoading = true;
				this.$api.assets.card.preview({year: Number(this.checkYear), month: Number(this.checkMonth)}).then(({data}) => {
					this.depLines = data || [];
					this.showDepModal = true;
				}).finally(() => this.depLoading = false);
			},
			doDepreciate() {
				this.depLoading = true;
				this.$api.assets.card.depreciate({year: Number(this.checkYear), month: Number(this.checkMonth)}).then(() => {
					this.$Message('折旧计提成功~');
					this.showDepModal = false;
				}).catch(() => {
				}).finally(() => this.depLoading = false);
			},
			salaryAccruePreview() {
				this.salaryLoading = true;
				this.$api.salary.bill.accruePreview({year: Number(this.checkYear), month: Number(this.checkMonth)}).then(({data}) => {
					this.salaryLines = data || [];
					this.showSalaryModal = true;
				}).catch(() => {
				}).finally(() => this.salaryLoading = false);
			},
			doSalaryAccrue() {
				this.salaryLoading = true;
				this.$api.salary.bill.accrue({year: Number(this.checkYear), month: Number(this.checkMonth)}).then(() => {
					this.$Message('工资计提成功~');
					this.showSalaryModal = false;
				}).catch(() => {
				}).finally(() => this.salaryLoading = false);
			},
			init() {
				this.$api.voucher.carryForwardMoney({
					years: this.checkYear,
					month: this.checkMonth,
					code: this.typeList.map(val => val.code)
				}).then(({data}) => {
					this.money = data;
				});
			},
			codeConversion(code) {
				code = String(code);
				let encoding = this.currentAccountSets.encoding.split('-');
				let reg = RegExp(`^\\d{4}(\\d{${encoding[1]}|\\d{${encoding[1]}\\d{${encoding[2]}|\\d{${encoding[1]}\\d{${encoding[2]}\\d{${encoding[3]})$`);
				if (!reg.test(code)) {
					code = this.updateCode(code, [4, 2, 2, 2], encoding);
				}
				return code;
			},
			updateCode(code, model, newModel) {
				let codeSp = [];
				let start = 0;
				for (let i in model) {
					let len = model[i];
					if (code.length <= start) {
						break;
					}
					codeSp.push(code.substring(start, Math.min(code.length, start + len)));
					start += len;
				}

				for (let i = 0; i < codeSp.length; i++) {
					let item = codeSp[i];
					let len = parseInt(newModel[i]);
					if (item) {
						if (item.length < len) {
							item = StringUtils.pad(item, item.length - len, "0");
						} else if (item.length > len) {
							item = item.substring(item.length - len);
						}
						codeSp[i] = item;
					}
				}

				return codeSp.join("");
			}
		},
		mounted() {
			this.checkData = {checkYear: this.checkYear, checkMonth: this.checkMonth};
			this.init();
		}
	}
</script>

<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		color: #000;
		border-radius: 3px;
		text-align: center;
		background-color: #Fff;
		height: 150px;
		line-height: 36px;
		border: 1px solid #eee;
	}

	.pnumber {
		margin: 5px 0;
		font-size: larger;
	}

	.dep-table {
		width: 100%;
		border-collapse: collapse;

		th, td {
			border-bottom: 1px solid #eee;
			padding: 8px 10px;
		}

		th {
			background: #f8f8f8;
		}
	}

</style>
